export const rogueSessionTypes = ['V Cloud', 'Open Nebula']

export const METHOD_LIST = 'rogue-session/';
export const METHOD_CREATE = 'rogue-session/';
export const Method_Activate_Lab_Url = 'rogue-session';

//language constants
export const MSG_WARNING_DELETE = 'Are you sure to delete live/suspended session for this user?';
export const MSG_DELETE_SUCCESS = 'Deleted Successfully';
